import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CalculationService, DataService, DateService, FormatService, HelperService, HTTPService } from 'app/services';
import { config } from 'app/constants';

import { currency } from 'app/constants/currency.constants';
import { datetimeFormat } from 'app/constants/date-time-format';
import { find, sum } from 'lodash';

@Component({
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService],
  selector: 'app-apply-credit-payment',
  styleUrls: ['./apply-credit-payment.component.scss'],
  templateUrl: './apply-credit-payment.component.html',
})
export class ApplyCreditPaymentComponent implements OnInit {
  public RO = [];
  public usd = currency.USD;
  public validate = [];
  public paymentId: any;
  public focus: any = [];
  public maxDateRange: any = new Date();
  public payment: any = {
    _id: '',
    code: '',
    collectedAmount: null,
    creditToApply: 0,
    customer: {
      customerId: '',
      email: '',
      fullName: '',
      phone: '',
    },
    estimate: {
      card: 0,
      cash: 0,
      cheque: 0,
      creditPayment: 0,
      thirdParty: 0,
      code: '',
      estimateBy: '',
      estimateId: '',
      invCode: '',
      title: '',
      total: 0,
    },
    notes: '',
    history: [],
  };
  public paymentTime: any = '';
  public isQboConnected: any = false;
  public searchQuery = '';
  public isProcessing = false;
  public isProcessingQBO = false;
  public format = datetimeFormat;
  public defaultTitle: string = config.defaultTitle;
  public orderVehicle: any;
  public remainingBalance: any = 0;
  public workFlowDisabled: boolean = false;
  public remainingBalanceValidation: boolean = false;
  public previousCollectedAmount: number = 0;
  public collectedAmmount: any;
  public disabled: boolean = false;
  public availableCredits = [];
  public cols = [
    { header: 'Memo #', field: 'code', class: 'title' },
    { header: 'Initial credit', field: 'amount', class: 'amount' },
    { header: 'Remaining', field: 'remainingAmount', class: 'amount' },
    { header: 'Apply now', field: 'appliedAmount', class: 'apply-now' },
  ];
  constructor(
    public httpService: HTTPService,
    public helperService: HelperService,
    public dataService: DataService,
    public dateService: DateService,
    public ref: DynamicDialogRef,
    public dConfig: DynamicDialogConfig,
    public calculationService: CalculationService,
    private formatService: FormatService
  ) {}

  public ngOnInit() {
    const data = this.dConfig.data;
    this.isQboConnected = this.helperService.getCompany().qbo;

    if (data) {
      this.paymentId = data.memoId;
      this.payment = data;
      if (data.estimate && data.estimate.customer) {
        this.searchQuery = data.estimate.customer.fullName;
        this.payment.customer = data.estimate.customer;
      }

      const estimate = data.estimate ? data.estimate : '';

      if (estimate) {
        this.getAllCreditMemo();
        this.setEstimateDetails(estimate);
      }
    }
  }

  /** Populate Estimate Details */
  public setEstimateDetails(order: any) {
    const customer = order.customer || {};
    this.payment = {
      ...this.payment,
      customer: {
        customerId: customer.customerId,
        fullName: customer.fullName,
        email: customer.email,
        phone: customer.phone,
        phone2: customer.phone2,
        notes: customer.notes,
        displayName: customer.displayName,
      },
      estimate: {
        estimateId: order._id,
        title: order.title,
        code: order.code,
        invCode: order.invCode,
        workFlowStatus: (order.workFlowStatus && order.workFlowStatus.name) || '',
        // createdAt: "2022-08-16T08:25:31.000Z"
        isActive: order.isActive,
      },
    };

    if (order.vehicle && order.vehicle.vehicleId && order.vehicle.vehicleId._id) {
      this.orderVehicle = order.vehicle.vehicleId;
    }

    this.httpService.getEstimatePaymentDetails(order._id).then(
      (estimate: any) => {
        if (estimate.vehicle && estimate.vehicle.vehicleId) {
          this.orderVehicle = estimate.vehicle.vehicleId;
        }

        this.payment = {
          title: order.title,
          code: order.code,
          collectedAmount: this.availableCredits.length > 0 && this.availableCredits.map((memo) => memo.remainingAmount).reduce((acc, val) => acc + val),
          isPaidFull: estimate.isPaidFull,
          workFlowPaid: order.workFlowStatus && order.workFlowStatus.name,
          creditToApply: 0,
          customer: {
            customerId: estimate.customer && estimate.customer.customerId,
            fullName: estimate.customer && estimate.customer.fullName,
            email: estimate.customer && estimate.customer.email,
            phone: estimate.customer && estimate.customer.phone,
            phone2: estimate.customer && estimate.customer.phone2,
            notes: estimate.customer && estimate.customer.notes,
            displayName: estimate.customer && estimate.customer.displayName,
            isFleetCustomer: estimate.customer && estimate.customer.isFleetCustomer,
          },
          estimate: {
            estimateId: order._id,
            title: order.title,
            code: order.code,
            invCode: estimate.invCode,
            workFlowStatus: (order.workFlowStatus && order.workFlowStatus.name) || '',
            cash: this.calculationService.roundOff(estimate.cash),
            cheque: this.calculationService.roundOff(estimate.cheque),
            card: this.calculationService.roundOff(estimate.card),
            creditPayment: this.calculationService.roundOff(estimate.creditPayment),
            thirdParty: this.calculationService.roundOff(estimate.thirdParty),
            total: estimate.total.grand,
            unpaid: estimate.total.unpaid,
            createdAt: this.dateService.getCurrentDateTimeTz(new Date(estimate.backdatedCreationDate || estimate.createdAt).getTime()),
            paid: sum([
              this.calculationService.roundOff(estimate.card),
              this.calculationService.roundOff(estimate.cheque),
              this.calculationService.roundOff(estimate.cash),
              this.calculationService.roundOff(estimate.creditPayment),
              this.calculationService.roundOff(estimate.thirdParty),
            ]),
          },
        };
        this.getReviewConfiguration();
        this.workFlowDisabled = this.payment.workFlowPaid === 'Paid';
        this.remainingBalance = this.renderRemainingAmount();
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  getAllCreditMemo() {
    this.httpService
      .getAllCreditMemo(this.payment.customer.customerId, true)
      .then((creditMemo: []) => {
        if (creditMemo && creditMemo.length > 0) {
          this.availableCredits = this.formatService.formatCustomerCreditMemo(creditMemo);
          this.payment.collectedAmount = this.availableCredits.length > 0 && this.availableCredits.map((memo) => memo.remainingAmount).reduce((acc, val) => acc + val);
        }
      })
      .catch((err) => this.helperService.showToaster('error', err));
  }

  renderRemainingAmount() {
    const { total, paid } = this.payment.estimate;
    return this.calculationService.roundOff(total - paid);
  }

  /** Getting amount from the input box and calculating the remaining balance */
  public handleChange(value: any, index: string) {
    this.availableCredits[index].appliedAmount = !isNaN(value.replace(',', '')) ? Number(value.replace(',', '')) : value;

    if (value > this.availableCredits[index].remainingAmount) {
      this.availableCredits[index].error = '* Amount must be less than the remaining balance';
    } else {
      this.availableCredits[index].error = '';
    }
    this.payment.creditToApply = this.availableCredits && this.availableCredits.map((memo) => memo.appliedAmount).reduce((acc, val) => acc + val);

    this.remainingBalance = this.payment.estimate.total - this.payment.estimate.paid - this.payment.creditToApply;
    this.remainingBalance = this.calculationService.roundOff(this.remainingBalance);

    if (this.remainingBalance < 0) {
      this.remainingBalanceValidation = true;
    } else {
      this.remainingBalanceValidation = false;
    }
  }

  public handleSelectRO(RO) {
    this.payment.estimate = RO;
  }

  public onDateTimeChange(date: any) {
    this.payment.paymentDate = date;
  }

  /** Getting review configuration */
  public getReviewConfiguration() {
    this.httpService.getReviewConfiguration().then(
      (configuration) => {
        this.paymentTime = this.dateService.getCurrentDateTimeTz(configuration.serverTime);
        this.payment.paymentDate = this.dateService.getCurrentDateTimeTz(configuration.serverTime);
        const maxDateRange = this.dateService.getCurrentDateTimeTz(configuration.serverTime);
        this.maxDateRange = new Date(maxDateRange);
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  public closePaymentModal(data?: any) {
    this.ref.close(data);
  }

  public handleFocus(index?) {
    this.availableCredits[index].focus = true;
    if (isNaN(this.availableCredits[index].appliedAmount)) {
      this.availableCredits[index].appliedAmount = 0;
    }
  }

  public removeFocus(index) {
    this.availableCredits[index].focus = false;
  }

  public onChangeNote(event) {
    if (this.paymentId) {
      this.payment.customer.notes = event;
    }
  }

  public onSubmit(isUpdateQBO) {
    this.createOrUpdateTransaction(isUpdateQBO);
  }

  /** Making a credit memo payment */
  public createOrUpdateTransaction(isUpdateQBO) {
    if (!this.validation()) {
      return;
    }

    const appliedCreditMemos = [];
    this.availableCredits.map((x) => {
      if (x.appliedAmount) {
        appliedCreditMemos.push(x);
      }
    });
    const payload = {
      _id: this.paymentId,
      amount: this.payment.collectedAmount,
      customer: this.payment.customer,
      date: this.dateService.formatDate(this.payment.paymentDate, datetimeFormat.yyymmddhhmm),
      estimate: this.payment.estimate,
      notes: this.payment.notes,
      appliedCreditMemos: appliedCreditMemos,
    };
    if (!isUpdateQBO) {
      this.isProcessing = true;
    }

    // payload._id;
    this.httpService
      .createApplyMemo(payload)
      .then(() => {
        this.helperService.showToaster('success', `Credit payment added`);
        this.dataService.sendData(this.dataService.typePassData('payment-list', {}));
        this.closePaymentModal();
      })
      .catch((err) => this.helperService.showToaster('error', err))
      .finally(() => (this.isProcessing = false));
  }

  public saveToQuickBook(isUpdateQBO = false) {
    this.onSubmit(isUpdateQBO);
  }

  /** Validate payment data */
  public validation() {
    this.focus.collectedAmount = false;

    const isFormValid = true;

    if (this.availableCredits.find((credit) => credit.error)) {
      this.helperService.showToaster('error', `Please select a valid apply amount`);
      return false;
    }

    if (this.payment.paymentDate && this.paymentTime) {
      const date = this.dateService.formatDate(this.payment.paymentDate, datetimeFormat.yyymmdd);
      const time = this.dateService.formatDate(this.paymentTime, datetimeFormat.hhmm);
      let paymentDate: any = new Date(`${date} ${time}`);

      if (this.helperService.isAppleDevice()) {
        paymentDate = new Date(this.dateService.madeDateStringIOSCompatible(`${date} ${time}`));
      } else {
        paymentDate = new Date(`${date} ${time}`);
      }

      if (paymentDate === 'Invalid Date') {
        this.helperService.showToaster('error', `Please select a valid date`);
        return false;
      }
    }

    return isFormValid;
  }

  public displayNameEmail(fullName: string, email: string) {
    if (fullName && email) {
      return `${fullName} - ${email}`;
    } else if (fullName) {
      return `${fullName}`;
    }
  }
}
